import { SettingsRoundnessLevel } from '../models';

export const roundnessLevelMap = {
  [SettingsRoundnessLevel.SOLID]: 'solid-roundness-theme',
  [SettingsRoundnessLevel.SEMI_ROUNDED]: 'semi-roundness-theme',
  [SettingsRoundnessLevel.ROUNDED]: 'full-roundness-theme',
};
